import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';

import type {GetNotificationsSettingsResponse} from '../../../dto/settings/GetNotificationsSettingsResponse';

export class GetNotificationsSettingsCommand extends Command<GetMethod, GetNotificationsSettingsResponse> {
  constructor() {
    super(get, {
      path: `/settings/notifications`,
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetNotificationsSettingsResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetNotificationsSettingsResponse>);
  }
}
